/**
 * The one place AFAR Research's public domain is written.
 *
 * The website, the Application Release Mirror, and every AFAR Cloud stage's hostnames are named
 * under this domain, and the preview stage nests one label deeper. Moving the domain is a change
 * here, plus the standalone installers, wizards, and docs that cannot import it.
 */
export const AFAR_RESEARCH_DOMAIN = "afar-research.archiv.technology";

/** `name` under the public domain, e.g. `app` → `app.afar-research.archiv.technology`. */
export const afarResearchHostname = (name: string): string => `${name}.${AFAR_RESEARCH_DOMAIN}`;
